import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=b29fdcba&scoped=true"
import script from "./ClickToEdit.vue?vue&type=script&lang=js"
export * from "./ClickToEdit.vue?vue&type=script&lang=js"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=b29fdcba&prod&scoped=true&lang=scss"
import style1 from "./ClickToEdit.vue?vue&type=style&index=1&id=b29fdcba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29fdcba",
  null
  
)

export default component.exports